import styled from '@emotion/styled';
import { Button, Icon as SystemIcon, theme } from '@hover/blueprint';

const Row = styled(Button)`
  border-bottom: 1px solid ${theme.colors.neutral[200]};
  ${({ disabled }) =>
    disabled
      ? `
    opacity: 0.3;
  `
      : ''}
  & div {
    justify-content: space-between;
  }
`;

const CancelButton = styled(Button)`
  border-radius: 0;
  background-color ${theme.colors.neutral[100]};
  color: ${theme.colors.neutral[600]};
  width: 100%;
`;

const Icon = styled(SystemIcon)`
  margin-left: auto;
`;
Icon.defaultProps = {
  color: 'neutral.700',
};

export { Row, CancelButton, Icon };
